import config from "config";
import { APICore } from "helpers/api/apiCore";
import { BulkCustomersDetail, BulkCustomersDownloadFileType, BulkCustomersFileCheckerRemarkType, BulkCustomersFileMakerRemarkType, BulkCustomersVersionType, uploadBulkCustomersFile } from "./types";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function uploadBulkCustomersFileApi(params: uploadBulkCustomersFile) {
    let formData = new FormData();
    formData.append("file", params.bulkCustomerFile);

    let backendApiUrl = `${config.BACKEND_BASE_URL}/bulk-file/customers`;

    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, formData);
}

function fetchBulkCustomersApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer`;
    return api.get(`${baseUrl}`, params);
}

function fetchBulkCustomersDetailApi(params: BulkCustomersDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer/${params.externalID}`;
    return api.get(`${baseUrl}`, null);
}


function fetchBulkCustomersVersionApi(params: BulkCustomersVersionType) {
    // TODO: change the backend URL to the correct one

    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.id}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function BulkCustomersPublishApi(params: BulkCustomersFileMakerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function downloadBulkCustomersFileApi(params: BulkCustomersDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, {});
}


function approveBulkCustomersFileApi(params: BulkCustomersFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}


function rejectBulkCustomersFileApi(params: BulkCustomersFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}


function fetchBulkFileSpecificCustomersApi(params: BulkCustomersVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customer/${params.id}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}

function deDuplicateBulkCustomersFileCheckApi(params: BulkCustomersDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/customers/${params.externalID}/pan-deduplication`;
    return api.create(`${baseUrl}`, null);
}

function deleteBulkCustomersFileApi(params: BulkCustomersDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}
export {
    uploadBulkCustomersFileApi,
    fetchBulkCustomersApi,
    fetchBulkCustomersDetailApi,
    fetchBulkCustomersVersionApi,
    BulkCustomersPublishApi,
    downloadBulkCustomersFileApi,
    approveBulkCustomersFileApi,
    rejectBulkCustomersFileApi,
    fetchBulkFileSpecificCustomersApi,
    deDuplicateBulkCustomersFileCheckApi,
    deleteBulkCustomersFileApi
};